import { controllers } from '../controllers';
import { DeviceI, HotelFeature } from '../redux/types/controllers';

type HotelFeatureDevice = Pick<DeviceI, 'name' | 'tech' | 'className' | 'icons' | 'thermostatAppliance'> & {
    hotelFeatures?: readonly string[];
};

export const getHotelFeatures = (device: HotelFeatureDevice): HotelFeature[] => {
    const features = device.hotelFeatures ?? controllers.find((template) =>
        template.name === device.name
        && template.tech === device.tech
        && template.className === device.className
        && template.icons === device.icons
        && template.thermostatAppliance === device.thermostatAppliance
    )?.hotelFeatures;

    return (features ?? []).filter((feature): feature is HotelFeature =>
        feature === 'doNotDisturb' || feature === 'makeUpRoom' || feature === 'doorbell'
    );
};
